module.exports = __webpack_public_path__ + "img/wchart.79bc87c7.png";